// Last Bookmark — final brand mark.
// A2 (bolder book outline) + A1's wider richer gold ribbon + 2-3 subtle page
// lines that disappear cleanly at favicon size. `currentColor` inherits the
// parent's forest brand tone; gold uses --sb-gold token.
export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Open book — bold outline for confident silhouette at any size */}
      <path d="M5 18 Q 20 14 32 21 Q 44 14 59 18 L 59 51 Q 44 47 32 53 Q 20 47 5 51 Z"
        fill="hsl(var(--sb-cream))" stroke="currentColor" strokeWidth="3.2" strokeLinejoin="round" />
      {/* Spine crease */}
      <path d="M32 21 L 32 53" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      {/* Subtle page ruling — drops below visual noise threshold at ~20px */}
      <line x1="14" y1="27" x2="26" y2="28" stroke="currentColor" strokeWidth="1" opacity="0.35" strokeLinecap="round" />
      <line x1="14" y1="33" x2="24" y2="34" stroke="currentColor" strokeWidth="1" opacity="0.35" strokeLinecap="round" />
      <line x1="38" y1="28" x2="50" y2="27" stroke="currentColor" strokeWidth="1" opacity="0.35" strokeLinecap="round" />
      <line x1="40" y1="34" x2="50" y2="33" stroke="currentColor" strokeWidth="1" opacity="0.35" strokeLinecap="round" />
      {/* Wide, rich gold ribbon */}
      <path d="M27 21 L 27 58 L 32 54 L 37 58 L 37 21 Z"
        fill="hsl(var(--sb-gold))" stroke="currentColor" strokeWidth="0.9" strokeLinejoin="round" />
      <line x1="32" y1="24" x2="32" y2="53" stroke="hsl(var(--sb-gold-2))" strokeWidth="0.7" opacity="0.55" />
    </svg>
  );
}

export function WordMark({ className = "", showMark = true }) {
  return (
    <div className={`flex items-center gap-2 sm:gap-2.5 ${className}`}>
      {showMark && <LogoMark size={54} className="text-[hsl(var(--sb-emerald))] sm:hidden" />}
      {showMark && <LogoMark size={62} className="text-[hsl(var(--sb-emerald))] hidden sm:block" />}
      {/* Wordmark color is theme-aware so it stays high-contrast on either
          nav background: deep forest ink on the light cream nav, warm
          honey/cream on the dark forest nav. */}
      <span className="font-serif text-xl sm:text-[1.7rem] font-semibold tracking-tight text-[hsl(var(--sb-forest))] dark:text-[hsl(40_60%_96%)]">
        Last Bookmark
      </span>
    </div>
  );
}

export function LogoFull({ className = "", maxWidth = 460 }) {
  return (
    <img
      src="/brand/last-bookmark-logo-tight.png"
      alt="Last Bookmark — Where Great Stories Meet Great Readers"
      className={className}
      style={{ maxWidth, width: "100%", height: "auto" }}
    />
  );
}
